import { string } from 'yup'

export default string().required().max(200, 'School name can be more than 200 characters')
